import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {timeout} from 'rxjs/operators';
import {environment} from '../../env';
import {DialogApi, DialogSessionPeek} from './dialog-api';
import {DialogTurnRequest, DialogTurnResponse} from './dialog.models';

// A turn can involve several sequential model calls server-side, bounded at roughly
// 6 calls / 8s for text. This leaves comfortable headroom above that budget rather
// than matching it exactly.
export const TURN_TIMEOUT_MS = 20_000;

@Injectable({providedIn: 'root'})
export class HttpDialogApi implements DialogApi {
  private readonly http = inject(HttpClient);

  turn(householdId: number, request: DialogTurnRequest): Observable<DialogTurnResponse> {
    const request$ = this.http.post<DialogTurnResponse>(
      `${environment.apiUrl}/households/${householdId}/dialog/turn`, request,
    );
    return environment.dialog.disableTimeouts ? request$ : request$.pipe(timeout(TURN_TIMEOUT_MS));
  }

  invalidateSession(householdId: number, sessionId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}/households/${householdId}/dialog/session/${sessionId}`,
    );
  }

  peekActiveSession(householdId: number): Observable<DialogSessionPeek> {
    return this.http.get<DialogSessionPeek>(
      `${environment.apiUrl}/households/${householdId}/dialog/session`,
    );
  }
}
